import React from 'react';
import {StyleSheet, View, Text, Platform} from 'react-native';
import Barcode from '../../components/barcode';
import {FONT_FAMILY_REGULAR, appBackgroundWhiteBG} from '../../utils/utils';
import logger from '../../utils/logger';
import 'array-flat-polyfill';

const BarCodeGenerator = props => {
   const barCodeValue = props.valueStr;
   logger('String for Encoding::' + barCodeValue);
   return (
      <View style={styles.container}>
         <View style={styles.card}>
            <Barcode
               value={barCodeValue}
               format="CODE128"
               height={200}
               width={Platform.OS === 'web' ? 4 : 0}
               singleBarWidth={4.5}
               fontSize={12}
               displayValue={false}
            />
            <Text
               style={{
                  fontSize: 12,
                  fontFamily: FONT_FAMILY_REGULAR,
                  marginTop: 8,
                  color: '#000',
               }}>
               {/* {Platform.OS !== 'web' ? barCodeValue : barCodeValue} */}
               {barCodeValue}
            </Text>
         </View>
      </View>
   );
};
const styles = StyleSheet.create({
   container: {
      flex: 1,
      flexDirection: 'column-reverse',
      justifyContent: 'center',
      alignItems: 'center',
   },
   card: {
      elevation: 3,
      backgroundColor: appBackgroundWhiteBG,
      shadowOffset: {width: 0, height: 1},
      shadowColor: '#333',
      shadowOpacity: 0.3,
      shadowRadius: 2,
      minHeight: 211,
      minWidth: 327,
      justifyContent: 'center',
      alignItems: 'center',
      padding: 8,
   },
});
export default BarCodeGenerator;
